import { ThemeEvents } from '@theme/events';

// Refresh restored/pre-rendered pages from Shopify, rather than their old HTML count.
let cartCountRequest = null;
let cartCountRevision = 0;

function refreshCartIconCounts() {
  if (cartCountRequest) return cartCountRequest;
  const revision = cartCountRevision;
  const cartUrl = new URL(Theme.routes.cart_url, window.location.origin);
  cartUrl.pathname = cartUrl.pathname.replace(/\/$/, '') + '.js';
  cartUrl.search = '';
  cartUrl.hash = '';

  cartCountRequest = fetch(cartUrl.toString(), {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      if (!response.ok) throw new Error('Cart count refresh failed');
      return response.json();
    })
    .then((cart) => {
      if (revision !== cartCountRevision || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('cart-icon [data-ref="cart-count"]').forEach((count) => {
        count.textContent = String(cart.item_count);
      });
    })
    .catch(() => {
      // Keep the last known count if the customer is temporarily offline.
    })
    .finally(() => { cartCountRequest = null; });
  return cartCountRequest;
}

window.addEventListener('pageshow', refreshCartIconCounts);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') refreshCartIconCounts();
});


class CartIcon extends HTMLElement {
  constructor() {
    super();
    this.cartCount = null;
    this.addToCartBehavior = null;

    this.clickHandler = this.handleClick.bind(this);
    this.cartUpdatedHandler = this.onCartUpdated.bind(this);
  }

  connectedCallback() {
    this.addToCartBehavior = this.dataset.addToCartBehavior || 'open_cart';

    this.cartCount = this.querySelector('[data-ref="cart-count"]');

    this.addEventListener('click', this.clickHandler);
    document.addEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);
    refreshCartIconCounts();
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);
    this.removeEventListener('click', this.clickHandler);
  }

  getCurrentItemCount() {
    return parseInt(this.cartCount.textContent);
  }

  onCartUpdated(event) {
    cartCountRevision += 1;
    const { itemCount, source, sections } = event.detail.data;

    if (typeof itemCount === 'number') {
      this.#setCount(itemCount);
    }

    if (this.addToCartBehavior === 'open_cart' && source !== 'cart-reservation-timer') {
      this.openCart();
    }

    if (sections) return;

    setTimeout(() => {
      this.ensureCartCountIsCorrect();
    }, 100);
  }

  #setCount(count) {
    if (!this.cartCount) return;
    this.cartCount.textContent = count;
  }

  // Cette fonction est utile pour les applications de gift ou autre qui viennent modifier le panier pendant sa mise à jour. Ca permet de s'assurer que le compteur est correct.
  ensureCartCountIsCorrect() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (!cartDrawer) return;

    let cartCount = 0;

    const cartItems = cartDrawer.querySelectorAll('[data-ref="cart-item"]');
    cartItems.forEach((cartItem) => {
      const input = cartItem.querySelector('[data-ref="quantity-selector-input"]');
      const quantity = parseInt(input?.value ?? cartItem.dataset.quantity ?? '0', 10);
      cartCount += Number.isNaN(quantity) ? 0 : quantity;
    });

    const nestedChildren = cartDrawer.querySelectorAll('[data-ref="cart-line-child"][data-quantity]');
    nestedChildren.forEach((child) => {
      const quantity = parseInt(child.dataset.quantity ?? '0', 10);
      cartCount += Number.isNaN(quantity) ? 0 : quantity;
    });

    if (cartCount != this.getCurrentItemCount()) {
      this.cartCount.textContent = cartCount;
    }
  }

  handleClick() {
    this.openCart();
  }

  openCart() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (cartDrawer) {
      cartDrawer.open();
    } else {
      window.location.href = Theme.routes.cart_url;
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
